import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import OrganizationService from '@forwardflow/services/OrganizationService'
import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useOrganizationDetails = (queryParams: PaginationQueryParams) => {
   const response = useSWR(
      [QUERY_KEYS.ORGANIZATION_DETAILS, { ...queryParams }],
      () => OrganizationService.getOrganizationDetails(queryParams),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate(),
   }
}

export const useGetStageMappings = () => {
   const response = useSWR(
      [QUERY_KEYS.GET_STAGE_MAPPINGS],
      () => OrganizationService.getStageMappings(),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate(),
   }
}
